export const flashSelector = (state) => state.ui.flash;
